import React, { useState } from 'react';
import Link from 'next/link';
import useWindowResize from 'pubweb-smokey/dist/hooks/useWindowResize';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths';
import { privacyDates } from '@utils/utils';

export const ClaytonEmployeeCACollectionContent = () => {
  const [isResponsive, setIsResponsive] = useState(false);

  useWindowResize(() => {
    window.innerWidth < desktop_breakpoint
      ? setIsResponsive(true)
      : setIsResponsive(false);
  }, [desktop_breakpoint]);

  return (
    <div className="clayton-employee-ca-notice-collection-content">
      <h1 className="centered-header">
        Notice at Collection and Privacy Policy for California Workforce
      </h1>
      <p>Effective Date: {privacyDates.effectiveDate}</p>
      <p>Last Revised on: {privacyDates.lastRevisedDate}</p>
      <p>Last Reviewed on: {privacyDates.lastReviewedDate}</p>
      <p>
        Clayton Homes, Inc. and its affiliates and subsidiaries (“Clayton,”
        “we,” or “our”) respect your privacy. This Notice and Privacy Policy
        applies to Clayton employees or job applicants who reside in California
        (“consumers” or “you”).
      </p>
      <h3 className="centered-header">Notice at Collection</h3>
      <p>
        The purpose of this Notice at Collection is to provide you with timely
        notice, at or before the point of collection, about the categories of
        personal information to be collected from you and the purpose for which
        the personal information will be used.{' '}
      </p>
      <h5 className="centered-header">General Personal Information</h5>
      <table>
        <tbody>
          <tr>
            <th>
              <h4 className="do-we-collect-heading">Do We collect?</h4>
            </th>
            <th>
              <h4 className="categories-personal-info-heading">
                Categories of Personal Information
              </h4>
            </th>
            <th>
              <h4 className="purposes-collection-heading">
                Purposes for Collection
              </h4>
            </th>
            <th>
              <h4 className="retention-policy-heading">Retention Policy</h4>
            </th>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                <strong>Identifiers</strong>: For example, a real name, alias,
                postal address, unique personal identifier, online identifier,
                Internet Protocol address, email address, account name, social
                security number, driver&apos;s license number, passport number,
                or other similar identifiers.
              </p>
            </td>
            {!isResponsive ? noticeCollectionGenInfo() : null}
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                <strong>
                  Personal Information Categories from Cal. Civ. Code §
                  1798.80(e)
                </strong>
                : For example, name, Social Security number, address, telephone
                number, passport number, driver&apos;s license or state
                identification card number, insurance policy number, education,
                employment, employment history, medical information, or health
                insurance information.
              </p>
            </td>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                <strong>
                  Characteristics of CA or Federal Protected Classifications
                </strong>
                : For example, race, religion, national origin), age (40 and
                over), gender, medical condition, familial status, disability,
                or veteran status.
              </p>
            </td>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                <strong>Internet or Other Similar Network Activity</strong>: For
                example, browsing history, search history, and information
                regarding your interaction with an Internet Web site,
                application, or advertisement
              </p>
            </td>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                <strong>Sensory or Surveillance Data</strong>: For example,
                audio, electronic, visual, or similar information that can be
                linked or associated with a particular consumer or household
              </p>
            </td>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                <strong>Professional or Employment-Related Information</strong>:
                For example, compensation, evaluations, performance reviews,
                personnel files and current and past job history.
              </p>
            </td>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                <strong>Profile Data</strong>: For example, information about
                your behavior and aptitudes.
              </p>
            </td>
            {isResponsive ? noticeCollectionGenInfo() : null}
          </tr>
        </tbody>
      </table>
      <h5 className="centered-header">Sensitive Personal Information</h5>
      <table>
        <tbody>
          <tr>
            <th>
              <h4 className="do-we-collect-heading">Do We collect?</h4>
            </th>
            <th>
              <h4 className="categories-personal-info-heading">
                Categories of Sensitive Personal Information
              </h4>
            </th>
            <th>
              <h4 className="purposes-collection-heading">
                Purposes for Collection
              </h4>
            </th>
            <th>
              <h4 className="retention-policy-heading">Retention Policy</h4>
            </th>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                Social Security Number, Driver&apos;s License, State
                Identification Card, or Passport Number
              </p>
            </td>
            {!isResponsive ? noticeCollectionSensitiveInfo() : null}
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                Account log-in, financial account, debit card, or credit card
                number when provided with any required security or access code,
                password, or credentials allowing access to an account
              </p>
            </td>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>
                Racial or ethnic origin, citizenship or immigration status,
                religious or philosophical beliefs, or union membership
              </p>
            </td>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>Genetic data</p>
            </td>
          </tr>
          <tr>
            <td className="do-we-collect-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="categories-personal-info-content">
              <p>Health information</p>
            </td>
            {isResponsive ? noticeCollectionSensitiveInfo() : null}
          </tr>
        </tbody>
      </table>
      <p>
        We will not collect additional categories of personal information
        without providing you a new Notice at Collection disclosing those
        categories.
      </p>
      <p>
        Clayton does not sell your personal information to third parties or
        share information with third parties for cross context behavioral
        advertising.
      </p>
      <p>
        To review our Privacy Policy, please click{' '}
        <Link href="/privacy/multi-state-privacy-policy">here</Link>.
      </p>
      <h3 className="centered-header">Privacy Policy</h3>
      <p>
        The purpose of this privacy policy is to provide you with a
        comprehensive description of our online and offline practices regarding
        the collection, use, disclosure, retention, sharing, and sale of
        personal information and of your rights regarding your personal
        information.
      </p>
      <h5 className="centered-header">Your Right to Know</h5>
      <p>You have the right to request any of the following:</p>
      <ul>
        <li>
          the categories of personal information we have collected about you.
        </li>
        <li>
          the categories of sources from which the personal information is
          collected.
        </li>
        <li>
          the business or commercial purpose for collecting your personal
          information.
        </li>
        <li>
          the categories of third parties to whom we disclose personal
          information.
        </li>
        <li>
          the specific pieces of personal information we have collected about
          you.
        </li>
      </ul>
      <p>
        You can do this through a verified consumer request. That process is
        described below in the section, “Submitting a Verified Consumer
        Request.”
      </p>
      <p>
        The following table includes disclosures for the preceding 12 months of:
        categories of personal information we have collected about you as a job
        applicant or employee, the categories we have disclosed for a business
        purpose, and categories of third parties with whom we shared the
        personal information during that period.
      </p>
      <h5 className="centered-header">General Personal Information</h5>
      <table>
        <tbody>
          <tr>
            <th>
              <h4 className="category-heading">Category</h4>
            </th>
            <th colSpan={2}>
              <h4 className="month-heading">
                In the preceding 12 months this category was:
              </h4>
              <div
                className="month-sub-headings"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                }}
              >
                <th>
                  <h4 className="collected-heading">Collected</h4>
                </th>
                <th>
                  <h4 className="disclosed-heading">Disclosed</h4>
                </th>
              </div>
            </th>
            <th>
              <h4 className="disclosure-heading">
                Business or Commercial Purpose for Collection & Disclosure
              </h4>
            </th>
            <th>
              <h4 className="third-party-heading">
                Categories of third parties to whom the information was
                disclosed
              </h4>
            </th>
          </tr>
          <tr>
            <td className="category-content">
              <h4>Identifiers</h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            {!isResponsive ? privacyPolicyGenInfo() : null}
          </tr>
          <tr>
            <td className="category-content">
              <h4>
                Personal Information Categories from Cal. Civ. Code § 1798.80(e)
              </h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
          </tr>
          <tr>
            <td className="category-content">
              <h4>
                Characteristics of CA or Federal Protected Classifications
              </h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
          </tr>
          <tr>
            <td className="category-content">
              <h4>Internet or Other Similar Network Activity</h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
          </tr>
          <tr>
            <td className="category-content">
              <h4>Geolocation Data</h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
          </tr>
          <tr>
            <td className="category-content">
              <h4>Sensory or Surveillance Data</h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
          </tr>
          <tr>
            <td className="category-content">
              <h4>Profile Data</h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            {isResponsive ? privacyPolicyGenInfo() : null}
          </tr>
        </tbody>
      </table>
      <h5 className="centered-header">Sensitive Personal Information</h5>
      <p>
        We do not use or disclose the below sensitive personal information of
        employees or applicants for purposes beyond the minimum purposes
        specified under CCPA.
      </p>
      <table>
        <tbody>
          <tr>
            <th>
              <h4 className="category-heading">Category</h4>
            </th>
            <th colSpan={2}>
              <h4 className="month-heading">
                In the preceding 12 months this category was:
              </h4>
              <div
                className="month-sub-headings"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                }}
              >
                <th>
                  <h4 className="collected-heading">Collected</h4>
                </th>
                <th>
                  <h4 className="disclosed-heading">Disclosed</h4>
                </th>
              </div>
            </th>
            <th>
              <h4 className="disclosure-heading">
                Business or Commercial Purpose for Collection & Disclosure
              </h4>
            </th>
            <th>
              <h4 className="third-party-heading">
                Categories of third parties to whom the information was
                disclosed
              </h4>
            </th>
          </tr>
          <tr>
            <td className="category-content">
              <h4>
                Social Security Number, Driver&apos;s License, State
                Identification Card, or Passport Number
              </h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            {!isResponsive ? privacyPolicySensitiveInfo() : null}
          </tr>
          <tr>
            <td className="category-content">
              <h4>
                Account log-in, financial account, debit card, or credit card
                number when provided with any required security or access code,
                password, or credentials allowing access to an account
              </h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
          </tr>
          <tr>
            <td className="category-content">
              <h4>
                Racial or ethnic origin, citizenship or immigration status,
                religious or philosophical beliefs, or union membership
              </h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
          </tr>
          <tr>
            <td className="category-content">
              <h4>Genetic Data</h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
          </tr>
          <tr>
            <td className="category-content">
              <h4>Health Information</h4>
            </td>
            <td className="collected-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            <td className="disclosed-content">
              <input
                type="checkbox"
                defaultChecked={true}
                disabled={true}
                readOnly={true}
              />
            </td>
            {isResponsive ? privacyPolicySensitiveInfo() : null}
          </tr>
        </tbody>
      </table>
      <p>
        The categories identified as collected in the tables above were
        collected from the following categories of sources:
      </p>
      <ul>
        <li>Information from you that you directly provide to us.</li>
        <li>
          Information from you that you provide passively from your use of your
          sites and services.
        </li>
        <li>
          Information about you from third party sources: We collect this
          information from sources including consumer data resellers.
        </li>
      </ul>
      <h5 className="centered-header">
        Selling to Third Parties or Sharing with Third Parties for Cross-Context
        Behavioral Advertising
      </h5>
      <p>
        We do not sell your personal information to third parties or share
        information with third parties for cross context behavioral advertising.
        We do not have actual knowledge that we sell or share the personal
        information of minors under 16 years of age.
      </p>
      <h5 className="centered-header">
        Your Right to Request Correction of Inaccurate Personal Information
      </h5>
      <p>
        You have the right to request correction of inaccurate personal
        information maintained by us. We may request documentation from you to
        determine the accuracy of the information maintained by us. If you
        provide us documentation either upon our request or through your own
        initiative, that documentation will only be used or maintained by us for
        the purpose of correcting your personal information and complying with
        our recordkeeping requirements under CCPA.
      </p>
      <p>
        Please note that as a job applicant or employee, we may not be able to
        change or correct certain information about you.
      </p>
      <p>
        We may deny your request if we have previously denied your same request
        to correct an alleged inaccuracy in the past six (6) months, unless you
        provide new or additional documentation that the information at issue is
        inaccurate.
      </p>
      <p>
        As an alternative to correction, we may delete the inaccurate
        information if it does not negatively impact you or if you consent to
        this deletion. We reserve the right to deny this request if allowed
        under law, or if we determine that the contested information is more
        likely than not accurate, based on the totality of circumstances. You
        can submit a correction request through a verified consumer request.
        That process is described below in the section, “Submitting a Verified
        Consumer Request.”
      </p>
      <h5 className="centered-header">
        Your Right to Request Deletion of Your Personal Information
      </h5>
      <p>
        You have the right to request that we delete any of your personal
        information collected by us, subject to certain exceptions. You can do
        this through a verified consumer request. That process is described
        below in the section, “Submitting a Verified Consumer Request.”
      </p>
      <p>
        There may be scenarios where we deny your deletion request. If that
        occurs, we will provide you with an explanation as to why we could not
        delete all or some of your personal information.
      </p>
      <h5 className="centered-header">
        Submitting a Verified Consumer Request
      </h5>
      <p>
        You have the right to submit verified consumer requests to know
        information, to correct information, or for deletion.
      </p>
      <p>
        The response to a request to know will provide all personal information
        collected and maintained about you since January 1, 2022, unless doing
        so proves impossible or would involve disproportionate effort. Please
        note that we are not required to provide personal information to you
        more than twice in a 12-month period. We cannot respond to your request
        or provide you with personal information if we cannot verify your
        identity or authority to make the request. We will only use personal
        information provided in a verifiable consumer request to verify the
        requestor&apos;s identity or authority to make the request.
      </p>
      <p>
        You can submit requests using the following{' '}
        <Link href="/privacy/data-privacy-request-form">web form</Link> or by
        calling toll-free 877-353-6053. Your request will be verified using
        information you provide as described on the{' '}
        <Link href="/privacy/data-privacy-request-form">web form</Link>. If you
        call 877-353-6053 you will be asked to provide the same information
        requested on the web form for verification purposes.
      </p>
      <p>
        If you submit a request that is not through one of these designated
        methods or is deficient in some manner unrelated to verification, we
        will either treat it as if it had been submitted in accordance with our
        designated methods or provide you with information on how to submit the
        request or remedy any deficiencies.
      </p>
      <p>
        Once we receive your verifiable consumer request, we will confirm
        receipt of the request within 10 business days describing our
        verification process. We will respond to your request within 45 calendar
        days, if we are able to verify your identity.
      </p>
      <p>
        If requests from you are manifestly unfounded or excessive in particular
        because of their repetitive character, we may either charge a reasonable
        fee or refuse to act on the request, notifying you of our reason for
        refusing to act. If we determine that the request warrants a fee, we
        will notify you of the reason for that determination and provide you
        with a cost estimate before completing your request.
      </p>
      <p>
        Requests to Know or Delete for Child Under the Age of 13: We do not
        knowingly collect information of minors under the age of 13.
      </p>
      <h5 className="centered-header">
        Using an Authorized Agent to Submit a Request
      </h5>
      <p>
        Only you, a person registered with the California Secretary of State, or
        a person you authorize to act on your behalf, may make a verifiable
        consumer request related to your personal information. You may also make
        a verifiable consumer request on behalf of your minor child. If you use
        an authorized agent, you may provide a power of attorney executed
        pursuant to California Probate Code sections 4000 to 4465. If a power of
        attorney that meets those provisions is not submitted, you will be
        required to verify your identity directly by submitting a verified
        consumer request according to the procedures in the section &quot;
        <Link href="/privacy/multi-state-privacy-policy/">
          Using an Authorized Agent to Submit a Request
        </Link>
        .&quot; If anyone purporting to be an authorized agent for a consumer
        contacts us, we will require proof that the authorized agent has been
        authorized to act on the consumer&apos;s behalf.
      </p>
      <h5 className="centered-header">Opt-Out Preference Signals</h5>
      <p>
        Some website browsers have an “opt-out preference signal” feature that
        lets you tell other websites and businesses that you do not want to have
        your personal information sold or shared with third parties. We are not
        required under CCPA to process any opt-out preference signals because we
        do not sell personal information to third parties or share personal
        information with third parties for cross-contextual behavioral
        advertising.
      </p>
      <h5 className="centered-header">
        Your Right to Non-Discrimination for the Exercise of a Privacy Right
      </h5>
      <p>
        We will not discriminate against you for exercising any of your CCPA
        rights. Unless permitted by the CCPA, we will not: retaliate against
        you, as an employee, applicant for employment, or independent
        contractor.
      </p>
      <h5 className="centered-header">Changes to Our Privacy Notice</h5>
      <p>
        We reserve the right to amend this privacy notice at our discretion and
        at any time. When we make changes to this privacy notice, we will post
        the updated notice on this page and update the notice&apos;s effective
        date.
      </p>
      <h5 className="centered-header">Contact for More Information</h5>
      <p>
        If you have any questions or comments about this notice, the ways in
        which Clayton collects and uses your information, your choices and
        rights regarding such use, or wish to exercise your rights under
        California law, please do not hesitate to contact us at:
      </p>
      <p>Phone: 877-353-6053</p>
      <p>
        Website:{' '}
        <Link href="/privacy/data-privacy-request-form">Request Form</Link>
      </p>
    </div>
  );
};

//Declaring below variables to reduce overall line count/repeating code
const noticeCollectionGenInfo = () => {
  return (
    <>
      <td className="purposes-collection-content" rowSpan={11}>
        <ul>
          <li>Comply with all applicable laws and regulations</li>
          <li>
            Recruit and evaluate job applicants and candidates for employment
          </li>
          <li>Conducting background and reference checks</li>
          <li>
            Manage your employment relationship with us, including, for example:
            onboarding, timekeeping, payroll, employee benefits, training and
            development, job performance, emergency contacts, workers
            compensation, reviews, promotions, discipline, termination, online
            employee accounts, and/or other human resource purposes.
          </li>
          <li>
            Manage and monitor employee access to company facilities, equipment,
            and systems.
          </li>
          <li>Conduct internal audits and workplace investigations.</li>
          <li>
            Investigate and enforce compliance with and potential breaches of
            Clayton policies and procedures.
          </li>
          <li>
            Engage in corporate transactions requiring review of employee
            records, such as for evaluating potential mergers and acquisitions
            of Clayton.
          </li>
          <li>
            Maintain commercial insurance policies and coverages, including for
            workers&apos; compensation and other liability insurance
          </li>
          <li>
            Perform workforce analytics, data analytics, and benchmarking.
          </li>
          <li>
            Administer and maintain Clayton&apos;s operations, including for
            safety purposes.
          </li>
          <li>
            To promote our products/services and employee subject matter
            expertise
          </li>
          <li>
            Exercise or defend the legitimate business interests and legal
            rights of Clayton and its employees
          </li>
        </ul>
      </td>
      <td className="retention-policy-content" rowSpan={11}>
        <p>
          We retain your information during the time we have an ongoing
          relationship with you. Our internal uses and retention for personal
          information varies by department and certain business units. We retain
          your information as reasonably necessary and proportionate to the
          purpose for which each category of information was collected and will
          be processed. Records, or portions thereof may be deleted when there
          is no longer a legal, compliance, or business purpose to retain your
          information. We retain all personal information for at least 3 years
          and can retain certain information for as long as 10 years, which may
          be longer depending on the circumstances.
        </p>
      </td>
    </>
  );
};
const noticeCollectionSensitiveInfo = () => {
  return (
    <>
      <td className="purposes-collection-content" rowSpan={6}>
        <ul>
          <li>Comply with all applicable laws and regulations</li>
          <li>
            Recruit and evaluate job applicants and candidates for employment
          </li>
          <li>Conducting background and reference checks</li>
          <li>
            Manage your employment relationship with us, including, for example:
            onboarding, timekeeping, payroll, employee benefits, training and
            development, job performance, emergency contacts, workers
            compensation, reviews, promotions, discipline, termination, online
            employee accounts, and/or other human resource purposes.
          </li>
          <li>
            Manage and monitor employee access to company facilities, equipment,
            and systems.
          </li>
          <li>Conduct internal audits and workplace investigations.</li>
          <li>
            Investigate and enforce compliance with and potential breaches of
            Clayton policies and procedures.
          </li>
          <li>
            Engage in corporate transactions requiring review of employee
            records, such as for evaluating potential mergers and acquisitions
            of Clayton.
          </li>
          <li>
            Maintain commercial insurance policies and coverages, including for
            workers&apos; compensation and other liability insurance
          </li>
          <li>
            Perform workforce analytics, data analytics, and benchmarking.
          </li>
          <li>
            Administer and maintain Clayton&apos;s operations, including for
            safety purposes.
          </li>
          <li>
            To promote our products/services and employee subject matter
            expertise
          </li>
          <li>
            Exercise or defend the legitimate business interests and legal
            rights of Clayton and its employees
          </li>
        </ul>
      </td>
      <td className="retention-policy-content" rowSpan={6}>
        <p>
          We retain your information, at minimum, during the time an individual
          is employed with us or an applicant who is interviewing for a position
          with Clayton. Our internal uses and retention for your information
          varies by department and certain business units. We retain your
          information as reasonably necessary and proportionate to the purpose
          for which each category of information was collected and will be
          processed. Employment records, or portions thereof may be deleted when
          there is no longer a legal, compliance, or business purpose to retain
          your information. We retain all personal information for at least 3
          years and can retain certain information for as long as 10 years,
          which may be longer depending on the circumstances.
        </p>
      </td>
    </>
  );
};
const privacyPolicyGenInfo = () => {
  return (
    <>
      <td className="disclosure-content" rowSpan={9}>
        <ul>
          <li>Comply with all applicable laws and regulations</li>
          <li>
            Recruit and evaluate job applicants and candidates for employment
          </li>
          <li>Conducting background and reference checks</li>
          <li>
            Manage your employment relationship with us, including, for example:
            onboarding, timekeeping, payroll, employee benefits, training and
            development, job performance, emergency contacts, workers
            compensation, reviews, promotions, discipline, termination, online
            employee accounts, and/or other human resource purposes.
          </li>
          <li>
            Manage and monitor employee access to company facilities, equipment,
            and systems.
          </li>
          <li>Conduct internal audits and workplace investigations.</li>
          <li>
            Investigate and enforce compliance with and potential breaches of
            Clayton policies and procedures.
          </li>
          <li>
            Engage in corporate transactions requiring review of employee
            records, such as for evaluating potential mergers and acquisitions
            of Clayton.
          </li>
          <li>
            Maintain commercial insurance policies and coverages, including for
            workers&apos; compensation and other liability insurance
          </li>
          <li>
            Perform workforce analytics, data analytics, and benchmarking.
          </li>
          <li>
            Administer and maintain Clayton&apos;s operations, including for
            safety purposes.
          </li>
          <li>
            To promote our products/services and employee subject matter
            expertise
          </li>
          <li>
            Exercise or defend the legitimate business interests and legal
            rights of Clayton and its employees
          </li>
        </ul>
      </td>
      <td className="third-party-content" rowSpan={9}>
        <ul>
          <li>
            Within Clayton: Personal Information will be shared with people
            within Clayton who have a “need to know” the information in
            connection with the recruitment and hiring process.
          </li>

          <li>
            Service Providers: Clayton uses third-party service providers to
            assist with the recruitment process, including the collection,
            processing, and validation of Personal Information. For example,
            payment processing for direct deposits and processing an
            employee&apos;s benefits or expenses. We do not allow our
            third-party service providers to use your data for their own
            purposes. We only permit them to process it for specified purposes
            and in accordance with our instructions, and they are required to
            keep it confidential.
          </li>
        </ul>
      </td>
    </>
  );
};
const privacyPolicySensitiveInfo = () => {
  return (
    <>
      <td className="disclosure-content" rowSpan={5}>
        <ul>
          <li>Comply with all applicable laws and regulations</li>
          <li>
            Recruit and evaluate job applicants and candidates for employment
          </li>
          <li>Conducting background and reference checks</li>
          <li>
            Manage your employment relationship with us, including, for example:
            onboarding, timekeeping, payroll, employee benefits, training and
            development, job performance, emergency contacts, workers
            compensation, reviews, promotions, discipline, termination, online
            employee accounts, and/or other human resource purposes.
          </li>
          <li>
            Manage and monitor employee access to company facilities, equipment,
            and systems.
          </li>
          <li>Conduct internal audits and workplace investigations.</li>
          Clayton
          <li>
            Engage in corporate transactions requiring review of employee
            records, such as for evaluating potential mergers and acquisitions
            of Clayton.
          </li>
          <li>
            Maintain commercial insurance policies and coverages, including for
            workers&apos; compensation and other liability insurance
          </li>
          <li>
            Perform workforce analytics, data analytics, and benchmarking.
          </li>
          <li>
            Administer and maintain Clayton&apos;s operations, including for
            safety purposes.
          </li>
          <li>
            To promote our products/services and employee subject matter
            expertise
          </li>
          <li>
            Exercise or defend the legitimate business interests and legal
            rights of Clayton and its employees
          </li>
        </ul>
      </td>
      <td className="third-party-content" rowSpan={5}>
        <ul>
          <li>
            Within Clayton: Personal Information will be shared with people
            within Clayton who have a “need to know” the information in
            connection with the recruitment and hiring process.
          </li>
          <li>
            Service Providers: Clayton uses third-party service providers to
            assist with the recruitment process, including the collection,
            processing, and validation of Personal Information. For example,
            payment processing for direct deposits and processing an
            employee&apos;s benefits or expenses. We do not allow our
            third-party service providers to use your data for their own
            purposes. We only permit them to process it for specified purposes
            and in accordance with our instructions, and they are required to
            keep it confidential.
          </li>
        </ul>
      </td>
    </>
  );
};
